import React from 'react'
import { ContactOfficeFragment } from '../src/model/fragments'
import { CompanyDetail } from './CompanyDetail'
import { WidthBound } from './WidthBound'

export interface MainContactsProps {
	offices: ContactOfficeFragment[]
}

export const MainContacts: React.FunctionComponent<MainContactsProps> = ({
	offices,
}) => {
	return (
		<WidthBound>
			<div className="mainContacts">
				{offices.map((office) => (
					<div className="mainContacts-item" key={office.id}>
						<div className="mainContacts-item-in">
							<CompanyDetail
								fallbackName={office.name}
								fallbackAddress={office.address}
							/>
						</div>
					</div>
				))}
			</div>
		</WidthBound>
	)
}
